import { render } from "./FooterSmall.vue?vue&type=template&id=44c8c931"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__